import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=503fac7c&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"
import style0 from "./Translations.vue?vue&type=style&index=0&id=503fac7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fac7c",
  null
  
)

export default component.exports